// src/page/LoginComercio.jsx
import { useState } from 'react';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import logo from '../asset/logoSumaSalto.png';
import Footer from "../asset/components/Footer";

export default function LoginComercio({ setComercioUser }) {
  const [email, setEmail] = useState('');
  const [clave, setClave] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const auth = getAuth();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const cred = await signInWithEmailAndPassword(auth, email, clave);
      const user = cred.user;

      // 🔐 Guardamos el usuario comercio en el estado global
      setComercioUser(user);

      navigate('/panel-comercio');
    } catch (err) {
      setError('Correo o clave incorrectos');
      console.error('Error login comercio:', err);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <img
        src={logo}
        alt="logoSumaSalto"
        style={{ height: '100px', width: 'auto', marginBottom: '1rem' }}
      />

      <form
        onSubmit={handleLogin}
        className="bg-white p-6 rounded-lg shadow-md w-full max-w-sm"
      >
        <h2 className="text-2xl font-semibold text-center mb-4">Login Comercio</h2>

        <input
          type="email"
          placeholder="Correo"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full mb-3 p-2 border rounded"
          required
        />

        <input
          type="password"
          placeholder="Clave"
          value={clave}
          onChange={(e) => setClave(e.target.value)}
          className="w-full mb-3 p-2 border rounded"
          required
        />

        {error && <p className="text-red-500 text-sm mb-2">{error}</p>}

        <button
          type="submit"
          className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 transition duration-200"
        >
          Iniciar Sesión
        </button>
      </form>

      <button
        onClick={() => navigate('/')}
        style={{
          marginTop: '20px',
          padding: '10px 20px',
          backgroundColor: '#1976d2',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          cursor: 'pointer',
          fontWeight: 'bold',
        }}
      >
        ← Volver al Inicio
      </button>

      <div className="flex flex-col min-h-screen">
        <main className="flex-grow">{/* Contenido principal */}</main>
        <Footer />
      </div>
    </div>
  );
}

